// Editor chrome: fonts, spacing, gutter colors, and pinned-range decoration
// styles. All values reference CSS custom properties from variables.css.
import { EditorView } from "@codemirror/view";

export const theme = EditorView.theme({
  "&": {
    backgroundColor: "transparent",
    fontFamily: "var(--font-mono)",
    fontSize: "11px",
    lineHeight: "20px",
  },
  ".cm-content": {
    padding: "8px 0",
    lineHeight: "20px",
    caretColor: "var(--text-primary)",
  },
  ".cm-cursor, .cm-dropCursor": {
    borderLeftColor: "var(--text-primary)",
  },
  ".cm-line": {
    lineHeight: "20px",
  },
  ".cm-scroller": {
    overflow: "auto",
    fontFamily: "var(--font-mono)",
    lineHeight: "20px",
  },
  "&.cm-focused": {
    outline: "none",
  },
  '&[data-readonly="true"] .cm-cursorLayer, &[data-readonly="true"] .cm-cursor':
    {
      display: "none",
    },
  ".cm-gutters": {
    backgroundColor: "transparent",
    border: "none",
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 8px 0 4px",
    minWidth: "24px",
    color: "color-mix(in srgb, var(--text-secondary) 60%, transparent)",
  },
  '&[data-readonly="true"] .cm-selectionLayer .cm-selectionBackground, &[data-readonly="true"].cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground':
    {
      background: "transparent !important",
    },
  "&.cm-editor .cm-scroller .cm-line ::selection, &.cm-editor .cm-scroller .cm-line::selection":
    {
      backgroundColor:
        "color-mix(in srgb, var(--sky-600) 30%, transparent) !important",
      color: "inherit !important",
    },
  ".cm-diff-added": {
    backgroundColor: "color-mix(in srgb, var(--green-400) 50%, transparent)",
  },
  ".cm-diff-removed": {
    backgroundColor: "color-mix(in srgb, var(--red-400) 50%, transparent)",
  },
  ".cm-diff-added-word": {
    backgroundColor: "color-mix(in srgb, var(--green-600) 32%, transparent)",
    paddingBlock: "3.5px",
  },
  ".cm-diff-removed-word": {
    backgroundColor: "color-mix(in srgb, var(--red-600) 32%, transparent)",
    paddingBlock: "3.5px",
  },
  ".cm-pinned": {
    backgroundColor: "color-mix(in srgb, var(--purple-600) 45%, transparent)",
    paddingBlock: "3.5px",
  },
  ".cm-searchMatch": {
    backgroundColor: "color-mix(in srgb, var(--green-600) 20%, transparent)",
    paddingBlock: "3.5px",
  },
  ".cm-searchMatch-selected": {
    backgroundColor: "color-mix(in srgb, var(--green-600) 60%, transparent)",
    paddingBlock: "3.5px",
  },
  ".cm-panels, .cm-panels.cm-panels-top": {
    display: "none",
  },
});
